'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionPlayForWork = function ActionPlayForWork(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11 5v5.59H7.5l4.5 4.5 4.5-4.5H13V5h-2zm-5 9c0 3.31 2.69 6 6 6s6-2.69 6-6h-2c0 2.21-1.79 4-4 4s-4-1.79-4-4H6z' })
  );
};
ActionPlayForWork = (0, _pure2.default)(ActionPlayForWork);
ActionPlayForWork.displayName = 'ActionPlayForWork';
ActionPlayForWork.muiName = 'SvgIcon';

exports.default = ActionPlayForWork;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/action/play-for-work.js
// module id = 1011
// module chunks = 0